import React from "react";
import { Dialog, DialogTitle, DialogContent, Slide, Box, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import bgImage from "assets/images/seller.png";
import buyer from "assets/images/buyer.png";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function SignUpDialog({ open, onClose }) {
  const navigate = useNavigate();

  const handleSelect = (role) => {
    onClose(); // إغلاق النافذة
    if (role === "buyer") {
      localStorage.setItem("user-type", "buyer"); // حفظ التوكن
      navigate("/authentication/sign-up");
    } else if (role === "seller") {
      localStorage.setItem("user-type", "seller"); // حفظ التوكن
      navigate("/authentication/sign-up");
    }
  };

  return (
    <><Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle textAlign="center">اختر نوع الحساب</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box
              onClick={() => handleSelect("buyer")}
              sx={{
                borderRadius: 2,
                textAlign: "center",
                p: 3,
                cursor: "pointer",
                "&:hover": { borderColor: "primary.main", backgroundColor: "#f5f5f5" },
              }}
            >
              <img src={buyer} alt="Buyer" width="100%" height="194px" />
              <Typography
                variant="h6"
                mt={2}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  p: 2,
                  borderRadius: 2,
                }}
              >
                تسجيل كمشتري
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              onClick={() => handleSelect("seller")}
              sx={{
                borderRadius: 2,
                textAlign: "center",
                p: 3,
                cursor: "pointer",
                "&:hover": { borderColor: "primary.main", backgroundColor: "#f5f5f5" },
              }}
            >
              <img src={bgImage} alt="Seller" width="100%" height="194px" />
              <Typography
                variant="h6"
                mt={2}
                sx={{
                  background: "linear-gradient(90deg, #ca9937, #e0b15a)",
                  p: 2,
                  borderRadius: 2,
                }}
              >
                تسجيل كبائع
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
      </>
  );
}
